import styled from 'styled-components'

const BaseToggleButton = styled.button`
  appearance: none;
  background-color: ${props =>
    props.theme.colors[props.disabled ? 'blue700' : 'white']};
  border: 1px solid ${props => props.theme.colors.blue700};
  color: ${props => props.theme.colors[props.disabled ? 'white' : 'blue700']};
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  opacity: 1 !important; // Override Bootstrap styles inherited from the layout >__>
  padding: ${props => props.theme.space[3]};
  transition: 0.15s background-color linear;

  &:not([disabled]):hover {
    background-color: ${props => props.theme.colors.blue100};
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 1px ${props => props.theme.colors.white},
      0 0 0 3px ${props => props.theme.colors.blue700};
  }
`

export default BaseToggleButton
